export const IMAGES_BASE_URL = 'https://redcarpet-im2.luxottica.com'
